import { includesNoCase } from '../../utils/strings';

function lazyWrapper<T>(fn: () => Promise<{ default: T }>, retriesLeft = 5, interval = 1000): Promise<{ default: T }> {
    return new Promise((resolve, reject) => {
        // check if the window has already been refreshed
        const hasRefreshed = JSON.parse(window.sessionStorage.getItem('retry-lazy-refreshed') || 'false');
        fn()
            .then((res) => {
                window.sessionStorage.setItem('retry-lazy-refreshed', 'false'); // success so reset the refresh
                resolve(res);
            })
            .catch((error) => {
                setTimeout(() => {
                    // not been refreshed yet
                    if (
                        !hasRefreshed &&
                        (error.name === 'ChunkLoadError' || includesNoCase(error.message, 'Loading chunk'))
                    ) {
                        window.sessionStorage.setItem('retry-lazy-refreshed', 'true'); // we are now going to refresh
                        window.location.reload(); // refresh the page
                        return;
                    }
                    if (retriesLeft === 1) {
                        reject(error);
                        return;
                    }
                    lazyWrapper(fn, retriesLeft - 1, interval).then(resolve, reject);
                }, interval);
            });
    });
}

export default lazyWrapper;
